import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ApprovalResultClientModel } from "../../api/v1";
import { BASE_QUERY_KEY } from "../../utils/constants";

import useAccessRequestsApi from "./use-access-requests-api";

export default function useApproveAccessRequest(id: string) {
  const queryClient = useQueryClient();
  const api = useAccessRequestsApi();

  const {
    mutate: approveAccessRequest,
    mutateAsync: approveAccessRequestAsync,
    ...rest
  } = useMutation(async (payload: ApprovalResultClientModel) => {
    const res = await api.approveAccessRequest({
      id,
      approvalResultClientModel: payload,
    });

    queryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });

    return res;
  });

  return {
    approveAccessRequest,
    approveAccessRequestAsync,
    ...rest,
  };
}
